import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { customerServiceProjectSettingsRedirectRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/customerServiceProjectSettingsRedirectRoute.tsx';
import { customerServiceProjectSettingsRedirectEntrypoint } from '@jira/redirect-entrypoints__customer-service-project-settings-redirect/src/customerServiceProjectSettingsRedirectEntrypoint.entrypoint.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const customerServiceProjectSettingsRedirectPageEntryPoint = createPageEntryPoint({
	main: customerServiceProjectSettingsRedirectEntrypoint,
});

export const customerServiceProjectSettingsRedirectRouteEntry: Route = createEntry(
	customerServiceProjectSettingsRedirectRoute,
	() => ({
		group: 'project-settings-customer-service',
		perfMetricKey: 'customer-service.project-settings',
		layout: serviceProjectLayout,
		isRedirect: true,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? customerServiceProjectSettingsRedirectPageEntryPoint
				: notFoundPageEntrypoint,
		// eslint-disable-next-line jira/router/no-project-context-resource
		resources: [...getNavigationResources(), projectContextResource],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
